/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallFinishedWebhookPayload } from '../../models/call-finished-webhook-payload';

export interface PostCallFinishedWebhookSchema$Params {
}

export function postCallFinishedWebhookSchema(http: HttpClient, rootUrl: string, params?: PostCallFinishedWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CallFinishedWebhookPayload>> {
  const rb = new RequestBuilder(rootUrl, postCallFinishedWebhookSchema.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CallFinishedWebhookPayload>;
    })
  );
}

postCallFinishedWebhookSchema.PATH = '/api/webhooks/notifications/events/CallFinished';
